module.exports = require('./dist/cjs/site/index');
